import { lazy } from 'react';
import Loadable from 'components/Loadable';

const ProjectExecutiveDashboard = Loadable(lazy(() => import('./components/project-executive-dashboard/ProjectExecutiveDashboard')));
const ProjectsList = Loadable(lazy(() => import('./components/projects-list/ProjectsList')));
const ClientMaster = Loadable(lazy(() => import('./components/client-master/ClientMaster')));
const ProjectTasks = Loadable(lazy(() => import('./components/project-tasks/ProjectTasks')));
const ProjectTaskDetail = Loadable(lazy(() => import('./components/project-task-detail/ProjectTaskDetail')));
const ProjectMilestones = Loadable(lazy(() => import('./components/project-milestones/ProjectMilestones')));
const ProjectReviews = Loadable(lazy(() => import('./components/project-reviews/ProjectReviews')));
const ProjectResources = Loadable(lazy(() => import('./components/project-resources/ProjectResources')));
const ProjectRisks = Loadable(lazy(() => import('./components/project-risks/ProjectRisks')));
const ProjectDetails = Loadable(lazy(() => import('./components/project-details/ProjectDetails')));
const ProjectTimesheets = Loadable(lazy(() => import('./components/project-timesheets/ProjectTimesheets')));
const ProjectReports = Loadable(lazy(() => import('./components/project-reports/ProjectReports')));
const ProjectAnalytics = Loadable(lazy(() => import('./components/project-analytics/ProjectAnalytics')));

export const projectRoutes = {
  path: 'projects',
  children: [
    { index: true, element: <ProjectExecutiveDashboard /> },
    { path: 'dashboard', element: <ProjectExecutiveDashboard /> },
    { path: 'list', element: <ProjectsList /> },
    { path: 'clients', element: <ClientMaster /> },
    { path: 'tasks', element: <ProjectTasks /> },
    { path: 'tasks/:taskId', element: <ProjectTaskDetail /> },
    { path: ':projectId/tasks', element: <ProjectTasks /> },
    { path: 'milestones', element: <ProjectMilestones /> },
    { path: 'reviews', element: <ProjectReviews /> },
    { path: 'resources', element: <ProjectResources /> },
    { path: 'risks', element: <ProjectRisks /> },
    { path: 'details/:id', element: <ProjectDetails /> },
    { path: 'projects/:id', element: <ProjectDetails /> },
    { path: 'timesheets', element: <ProjectTimesheets /> },
    { path: 'reports', element: <ProjectReports /> },
    { path: 'analytics', element: <ProjectAnalytics /> }
  ]
};

export default projectRoutes;
